<template>
  <div class="home">
    <div class="zip-finder">
      <HelloWorld msg="Welcome to Your Vue.js App"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',
  components: {
    HelloWorld,
  },
};
</script>

<style scoped>
.home {
  display: flex;
}
.zip-finder {
  margin: auto;
}
</style>
